import { SVGProps } from "react";

const SW = 1.5;

type NavIconProps = SVGProps<SVGSVGElement> & { size?: number };

function NavIcon({ size = 20, ...props }: NavIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} />
  );
}

export function DashboardNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <rect x="2.5" y="2.5" width="6" height="6" rx="1.25" stroke="currentColor" strokeWidth={SW} />
      <rect x="11.5" y="2.5" width="6" height="6" rx="1.25" stroke="currentColor" strokeWidth={SW} />
      <rect x="2.5" y="11.5" width="6" height="6" rx="1.25" stroke="currentColor" strokeWidth={SW} />
      <rect x="11.5" y="11.5" width="6" height="6" rx="1.25" stroke="currentColor" strokeWidth={SW} />
    </NavIcon>
  );
}

export function UsersNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <circle cx="7" cy="7.5" r="2.25" stroke="currentColor" strokeWidth={SW} />
      <path
        d="M3.5 16.5V15.5C3.5 13.84 4.84 12.5 6.5 12.5H7.5C9.16 12.5 10.5 13.84 10.5 15.5V16.5"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinecap="round"
      />
      <circle cx="13.5" cy="6.75" r="1.75" stroke="currentColor" strokeWidth={SW} />
      <path
        d="M11.25 16.5V15.75C11.25 14.37 12.37 13.25 13.75 13.25H14.25"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinecap="round"
      />
    </NavIcon>
  );
}

export function SitesNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <path
        d="M4 5.5L10 3L16 5.5V14.5L10 17L4 14.5V5.5Z"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinejoin="round"
      />
      <path d="M10 3V17" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
      <path d="M4 5.5L10 8.25L16 5.5" stroke="currentColor" strokeWidth={SW} strokeLinejoin="round" />
    </NavIcon>
  );
}

export function IntegrationsNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <path
        d="M3 10H5.25L7.25 6.5L9.75 13.5L12.25 7.75L14.25 10H17"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </NavIcon>
  );
}

export function BoxesNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <path
        d="M10 4L16.5 7.25V13.25L10 16.5L3.5 13.25V7.25L10 4Z"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinejoin="round"
      />
      <path d="M10 4V10.75" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
      <path d="M3.5 7.25L10 10.75L16.5 7.25" stroke="currentColor" strokeWidth={SW} strokeLinejoin="round" />
    </NavIcon>
  );
}

export function CamerasNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <path
        d="M4 7.5H13C14.1 7.5 15 8.4 15 9.5V13.5C15 14.6 14.1 15.5 13 15.5H4C2.9 15.5 2 14.6 2 13.5V9.5C2 8.4 2.9 7.5 4 7.5Z"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinejoin="round"
      />
      <path d="M15 10.5L18 9V14L15 12.5V10.5Z" stroke="currentColor" strokeWidth={SW} strokeLinejoin="round" />
      <circle cx="8.5" cy="11.5" r="2" stroke="currentColor" strokeWidth={SW} />
      <path
        d="M6.5 7.5L7.25 5.5H9.75L10.5 7.5"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </NavIcon>
  );
}

/** Clipboard for incident documentation */
export function IncidentsNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <path
        d="M7 3.5H13C13.8 3.5 14.5 4.2 14.5 5V16.5C14.5 17.3 13.8 18 13 18H7C6.2 18 5.5 17.3 5.5 16.5V5C5.5 4.2 6.2 3.5 7 3.5Z"
        stroke="currentColor"
        strokeWidth={SW}
      />
      <path d="M8 3.5H12V5H8V3.5Z" stroke="currentColor" strokeWidth={SW} strokeLinejoin="round" />
      <path d="M8 9H12" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
      <path d="M8 12H12" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
    </NavIcon>
  );
}

/** Bell outline for events / notifications */
export function EventsNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <path
        d="M10 3.25C7.65 3.25 5.75 5.15 5.75 7.5V11.25L4.5 12.5V13.25H15.5V12.5L14.25 11.25V7.5C14.25 5.15 12.35 3.25 10 3.25Z"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinejoin="round"
      />
      <path
        d="M8.25 13.25V13.75C8.25 14.72 9.03 15.5 10 15.5C10.97 15.5 11.75 14.72 11.75 13.75V13.25"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinecap="round"
      />
    </NavIcon>
  );
}

export function ProfileNavIcon(props: NavIconProps) {
  return (
    <NavIcon {...props}>
      <circle cx="10" cy="7" r="2.75" stroke="currentColor" strokeWidth={SW} />
      <path
        d="M4.75 16.25V15.25C4.75 12.9 6.65 11 9 11H11C13.35 11 15.25 12.9 15.25 15.25V16.25"
        stroke="currentColor"
        strokeWidth={SW}
        strokeLinecap="round"
      />
    </NavIcon>
  );
}
